module.exports = __webpack_public_path__ + "img/frame_1.d8a6f70a.png";